<template>
  <form @submit.prevent="save" class="w-m-content" v-if="!loading && !errors && !success">
    <div class="w-m-header">
      <div class="flex">
        <p class="font-14 font-bold no-margin col-grow" style="color: #293e52">Menu do site</p>
        <div class="">
          <!--<u-btn size="sm" flat label="Variáveis" icon="eye" icon-type="fa" @click="$refs.vars.show()" />-->
        </div>
      </div>
      <!--<div class="m-t-xs font-13 text-grey-7" style="color: #748396; padding-right: 20px; line-height: 1">Esta seção
        autoriza uma pessoa a acessar o software, com suas respectivas permissões.
      </div>-->
    </div>
    <div class="w-m-body e-input-modern flex">
      <div class="flex column w-full">
        <show-all ref="vars" />
        <e-row class="m-b-sm font-bold">
          Título:
        </e-row>
        <e-row class="m-b-sm">
          <e-col>
            <erp-input autofocus simple-border required placeholder="Ex.: Sobre nós"
                       v-model="model.title" />
          </e-col>
        </e-row>

        <e-row class="m-b-sm font-bold">
          Link:
        </e-row>
        <e-row class="m-b-sm">
          <e-col>
            <erp-input simple-border required placeholder="Ex.: https://dominio.com.br/page"
                       v-model="model.link" />
          </e-col>
        </e-row>

        <e-row class="m-b-sm m-t">
          <e-col>
            <strong>Seção:</strong>
            <e-row class="m-t-sm">
              <e-col>
                <label class="flex items-center m-b-xs" v-for="option in sectionOptions">
                  <u-radio v-model="model.section" :val="option.value" class="m-r-xs" />
                  {{option.label}}
                </label>
              </e-col>
            </e-row>
          </e-col>
        </e-row>

      </div>
    </div>
    <div class="w-m-footer text-right">
      <u-btn @click="excluir" v-if="id && !model.interno" label="Excluir" no-caps color="negative"
             class="b-radius-3px pull-left" />
      <u-btn type="submit" :label="id ? 'Atualizar' : 'Cadastrar'" no-caps :disable="!ready"
             :color="ready ? 'primary' : 'blue-grey-2'"
             class="b-radius-3px" />
    </div>
  </form>
  <window-success v-else-if="success">
    <div class="text-center">
      <u-icon name="check-circle" color="positive" type="fa" icon-style="solid" class="success-circle-140" />
    </div>
    <h5 class="m-t">Menu registrado com sucesso!</h5>
    <!--<div class="m-t text-blue-grey-7">
      Ela poderá ser utilizada em todo o sistema de templates/documentos.
    </div>-->
    <div class="text-center m-t">
      <timer-close-window ref="timer" @end="$uloc.window.close($root.wid)" />
    </div>
  </window-success>
  <window-loading :errors="errors" :status="status" v-else />
</template>

<script>
import ERow from '../../../../../layout/components/Row'
import {ErpInput} from 'uloc-vue-plugin-erp'
import ECol from '../../../../../layout/components/Col'
import WindowSuccess from '../../../../../layout/window/Success'
import TimerCloseWindow from '../../../../../layout/window/TimerClose'
import WindowLoading from '../../../../../layout/window/Loading'
import {
  newMenu as create,
  updateMenu as update,
  find,
  deleteMenu
} from '../../../../../../domain/menu-paginas/services'
import ShowAll from '../../../../../variaveis/components/showAll';
import {URadio} from 'uloc-vue'

let mock = {
  id: null,
  title: null,
  link: null,
  section: 1
}

export default {
  name: 'MenuWindowModern',
  components: {
    ShowAll,
    WindowLoading, TimerCloseWindow, WindowSuccess, ECol, ERow, ErpInput, URadio},
  props: ['props', 'id'],
  data () {
    return {
      model: JSON.parse(JSON.stringify(mock)),
      loading: !!this.id,
      errors: null,
      success: false,
      status: null,
      source: false,
      sectionOptions: [
        {label: 'Principal', value: 1},
        {label: 'Footer', value: 2}
      ]
    }
  },
  mounted () {
    this.id && this.load()
  },
  computed: {
    mock () {
      return mock
    },
    ready () {
      const mock = {...this.mock}
      delete mock.id
      const keysForChecking = Object.keys(mock)
      return keysForChecking.every(key => this.model[key])

    }
  },
  methods: {
    load () {
      find(this.id)
        .then(response => {
          console.log(response.data)
          this.model = response.data
          this.loading = false
        })
        .catch(error => {
          this.alertApiError(error)
          this.loading = false
        })
    },
    excluir () {
      this.$uloc.dialog({
        title: `Tem certeza que deseja excluir esta página?`,
        message: 'Digite EXCLUIR e clique para confirmar:',
        prompt: {
          model: '',
          type: 'text' // optional
        },
        cancel: true,
        color: 'negative'
      }).then(data => {
        if (data.toUpperCase() !== 'EXCLUIR') {
          this.$uloc.notify({
            color: 'negative',
            message: `Você não confirmou a operação. Exclusão não efetuada.`
          })
          return
        }
        this.$uloc.notify({
          color: 'negative',
          message: `Excluindo menu...`
        })
        deleteMenu(this.id)
          .then(response => {
            this.$uloc.notify({
              color: 'positive',
              message: `Menu deletado com sucesso!`
            })
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            this.$uloc.window.close(this.$root.wid)
          })
          .catch(error => {
            this.alertApiError(error)
          })
      }).catch(() => {
      })
    },
    save () {
      console.log('Save')
      this.loading = true

      let data = this.model

      let method = this.id ? (data) => update(this.id, data) : create
      method(data)
        .then(({data}) => {
          this.success = true
          Object.assign(this.model, data)
          this.$nextTick(() => {
            this.$uloc.window.emit(this.$root.wid, 'created', this.props)
            // this.$refs.timer.start()
          })
        })
        .catch(error => {
          this.success = false
          this.errorMessage = error.data.message
          // this.errors = this.systemError(error)
          this.$nextTick(() => {
            this.loading = false
            this.alertApiError(error)
            // this.error = true
          })
        })
    }
  }
}
</script>
